export default __webpack_public_path__ + "static/media/hht2_ep19_book_wp_01.bfe2af02.jpg";